import React from "react"
import Breadcrumbs2 from "components/Common/Breadcrumb2"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import { useFormik } from "formik"
import * as Yup from "yup"
import CompanyAction from "store/company-resource/actions"
import Select from "react-select"
import DatePicker from "react-flatpickr"
import { useHistory, useParams } from "react-router-dom"
import BranchesAction from "store/branch-resource/actions"
import Skeleton from "react-loading-skeleton"
import LoadingComponent from "components/Loading/LoadingComponent"
import { MetaTags } from "react-meta-tags"

export default function BrandCompany() {
  const dispatch = useDispatch()
  const history = useHistory()
  const store = useSelector(state => state)
  const params = useParams()

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      companyId: "",
      companyName: "",
      branchName: "",
      branchCode: "",
      companyCode: "",
      postalCode: "",
      prefectures: "",
      address: "",
      email: "",
      manager: "",
      closingDate: "",
      site: "",
      paymentDate: "",
      bettingRates: [
        {
          type: "",
          bettingRate: "",
        },
      ],
    },
    validationSchema: Yup.object({
      companyId: Yup.string().required("必須項目です。"),
      branchName: Yup.string().required("必須項目です。"),
      branchCode: Yup.string().required("必須項目です。"),
      postalCode: Yup.string().required("必須項目です。"),
      prefectures: Yup.string().required("必須項目です。"),
      address: Yup.string().required("必須項目です。"),
      email: Yup.string().required("必須項目です。"),
      manager: Yup.string().required("必須項目です。"),
      closingDate: Yup.string().required("必須項目です。"),
      site: Yup.number().required("必須項目です。"),
      paymentDate: Yup.string().required("必須項目です。"),
      bettingRates: Yup.array().of(
        Yup.object({
          type: Yup.string().required("必須項目です。"),
          bettingRate: Yup.string().required("必須項目です。"),
        })
      ),
    }),
    onSubmit: values => {
      if (params.id === "add") {
        dispatch(BranchesAction.postData(values, callbackPost))
      } else {
        dispatch(
          BranchesAction.putData({ ...values, id: params.id }, callbackPut)
        )
      }
    },
  })

  React.useEffect(() => {
    dispatch(CompanyAction.getList())
    dispatch(BranchesAction.getBettingRatesList())
  }, [])

  React.useEffect(() => {
    if (params.id !== "add") {
      dispatch(BranchesAction.getDetail({ id: params.id }, callbackGetDetail))
    }
  }, [params.id])

  const callbackPost = () => {
    history.push("/enterprise-customer-management")
    validation.resetForm()
  }

  const callbackPut = () => {
    history.push("/enterprise-customer-management")
    validation.resetForm()
  }

  const callbackGetDetail = data => {
    validation.setFieldValue("bettingRates", data.bettingRates)
    validation.setValues(data)
  }

  return (
    <>
      <MetaTags>
        <title>企業顧客管理 | Igarashi Trousers</title>
      </MetaTags>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs2 title="企業顧客管理" breadcrumbItems={[]} />

          <Card>
            <CardBody>
              {store.branches.detail.loading ? (
                <LoadingComponent />
              ) : (
                <Form
                  onSubmit={e => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                  }}
                >
                  <Row>
                    <Col md={8}>
                      <p className="fw-bold">
                        {params.id != "add"
                          ? "企業顧客管理詳細"
                          : "新規企業顧客管理追加"}
                      </p>
                    </Col>
                    <Col className="d-flex justify-content-end">
                      {params.id != "add" && (
                        <>
                          <br />
                          <Button
                            type="button"
                            className="button me-2"
                            onClick={() =>
                              history.push(
                                `/enterprise-customer-management/brand/${params.id}/history`
                              )
                            }
                          >
                            購入履歴
                          </Button>
                        </>
                      )}
                      {store.branches.saved.loading ? (
                        <Skeleton width={150} height={40} />
                      ) : (
                        <Button type="submit" className="button me-2">
                          保存
                        </Button>
                      )}

                      {store.branches.saved.loading ? (
                        <Skeleton width={150} height={40} />
                      ) : (
                        <Button
                          type="button"
                          className="button"
                          onClick={() =>
                            history.push("/enterprise-customer-management")
                          }
                        >
                          キャンセル
                        </Button>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col sm="8">
                      <FormGroup row>
                        <Label sm="2">会社名</Label>
                        <Col sm="6">
                          <Select
                            isLoading={store.company.list.loading}
                            options={store.company.list.data.map(i => ({
                              value: i.id,
                              label: i.name,
                              code: i.code,
                            }))}
                            defaultValue={{
                              value: validation.values.companyId,
                              label: validation.values.companyName,
                            }}
                            value={{
                              value: validation.values.companyId,
                              label: validation.values.companyName,
                            }}
                            onChange={e => {
                              validation.setFieldValue("companyId", e.value)
                              validation.setFieldValue("companyName", e.label)
                              validation.setFieldValue("companyCode", e.code)
                            }}
                          />
                          <Input
                            name="companyId"
                            className="form-control d-none"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.companyId || ""}
                            invalid={
                              validation.touched.companyId &&
                              validation.errors.companyId
                                ? true
                                : false
                            }
                          />
                          {validation.touched.companyId &&
                          validation.errors.companyId ? (
                            <FormFeedback type="invalid">
                              {validation.errors.companyId}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label sm="2">支店名</Label>
                        <Col sm="6">
                          <Input
                            name="branchName"
                            className="form-control"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.branchName || ""}
                            invalid={
                              validation.touched.branchName &&
                              validation.errors.branchName
                                ? true
                                : false
                            }
                          />
                          {validation.touched.branchName &&
                          validation.errors.branchName ? (
                            <FormFeedback type="invalid">
                              {validation.errors.branchName}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label sm="2">コード</Label>
                        <Col sm="4">
                          <Input
                            name="companyCode"
                            className="form-control"
                            disabled
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.companyCode || ""}
                            invalid={
                              validation.touched.companyCode &&
                              validation.errors.companyCode
                                ? true
                                : false
                            }
                          />
                          {validation.touched.companyCode &&
                          validation.errors.companyCode ? (
                            <FormFeedback type="invalid">
                              {validation.errors.companyCode}
                            </FormFeedback>
                          ) : null}
                        </Col>
                        <Col sm="2">
                          <Input
                            name="branchCode"
                            className="form-control"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.branchCode || ""}
                            invalid={
                              validation.touched.branchCode &&
                              validation.errors.branchCode
                                ? true
                                : false
                            }
                          />
                          {validation.touched.branchCode &&
                          validation.errors.branchCode ? (
                            <FormFeedback type="invalid">
                              {validation.errors.branchCode}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label sm="2">住所</Label>
                        <Col sm="12" className="ms-2">
                          <FormGroup row>
                            <Label sm="2">郵便番号</Label>
                            <Col sm="4">
                              <Input
                                name="postalCode"
                                className="form-control"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.postalCode || ""}
                                invalid={
                                  validation.touched.postalCode &&
                                  validation.errors.postalCode
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.postalCode &&
                              validation.errors.postalCode ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.postalCode}
                                </FormFeedback>
                              ) : null}
                            </Col>
                          </FormGroup>
                          <FormGroup row>
                            <Label sm="2">都道府県</Label>
                            <Col sm="4">
                              <Input
                                name="prefectures"
                                className="form-control"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.prefectures || ""}
                                invalid={
                                  validation.touched.prefectures &&
                                  validation.errors.prefectures
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.prefectures &&
                              validation.errors.prefectures ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.prefectures}
                                </FormFeedback>
                              ) : null}
                            </Col>
                          </FormGroup>
                          <FormGroup row>
                            <Label sm="2">住所</Label>
                            <Col sm="10">
                              <Input
                                name="address"
                                className="form-control"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.address || ""}
                                invalid={
                                  validation.touched.address &&
                                  validation.errors.address
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.address &&
                              validation.errors.address ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.address}
                                </FormFeedback>
                              ) : null}
                            </Col>
                          </FormGroup>
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label sm="2">メールアドレス</Label>
                        <Col sm="6">
                          <Input
                            name="email"
                            className="form-control"
                            type="email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                              validation.errors.email
                                ? true
                                : false
                            }
                          />
                          {validation.touched.email &&
                          validation.errors.email ? (
                            <FormFeedback type="invalid">
                              {validation.errors.email}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label sm="2">担当者</Label>
                        <Col sm="6">
                          <Input
                            name="manager"
                            className="form-control"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.manager || ""}
                            invalid={
                              validation.touched.manager &&
                              validation.errors.manager
                                ? true
                                : false
                            }
                          />
                          {validation.touched.manager &&
                          validation.errors.manager ? (
                            <FormFeedback type="invalid">
                              {validation.errors.manager}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>
                  <div className="w-100 border border-t-1 mb-3" />
                  <Row className="mb-2">
                    <Col sm="6">
                      <FormGroup row>
                        <Label sm="2">締日</Label>
                        <Col sm="6">
                          <DatePicker
                            name="closingDate"
                            className="form-control"
                            type="text"
                            onChange={date => {
                              validation.setFieldValue("closingDate", date[0])
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.closingDate || ""}
                            invalid={
                              validation.touched.closingDate &&
                              validation.errors.closingDate
                                ? true
                                : false
                            }
                          />
                          <Input
                            name="closingDate"
                            className="form-control d-none"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.closingDate || ""}
                            invalid={
                              validation.touched.closingDate &&
                              validation.errors.closingDate
                                ? true
                                : false
                            }
                          />
                          {validation.touched.closingDate &&
                          validation.errors.closingDate ? (
                            <FormFeedback type="invalid">
                              {validation.errors.closingDate}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label sm="2">サイト</Label>
                        <Col sm="6">
                          <Input
                            name="site"
                            className="form-control"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.site || ""}
                            invalid={
                              validation.touched.site && validation.errors.site
                                ? true
                                : false
                            }
                          />
                          {validation.touched.site && validation.errors.site ? (
                            <FormFeedback type="invalid">
                              {validation.errors.site}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label sm="2">支払い日</Label>
                        <Col sm="6">
                          <DatePicker
                            name="paymentDate"
                            className="form-control"
                            type="text"
                            onChange={date => {
                              validation.setFieldValue("paymentDate", date[0])
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.paymentDate || ""}
                            invalid={
                              validation.touched.paymentDate &&
                              validation.errors.paymentDate
                                ? true
                                : false
                            }
                          />
                          <Input
                            name="paymentDate"
                            className="form-control d-none"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.paymentDate || ""}
                            invalid={
                              validation.touched.paymentDate &&
                              validation.errors.paymentDate
                                ? true
                                : false
                            }
                          />
                          {validation.touched.paymentDate &&
                          validation.errors.paymentDate ? (
                            <FormFeedback type="invalid">
                              {validation.errors.paymentDate}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>

                      {validation.values.bettingRates.map((i, index) => (
                        <FormGroup row key={index}>
                          <Label sm="2">{index === 0 ? "掛け率" : ""}</Label>
                          <React.Fragment>
                            <Col sm="3">
                              <Select
                                isClearable
                                isLoading={store.branches.bettingRates.loading}
                                options={store.branches.bettingRates.data.map(
                                  i => ({ value: i, label: i })
                                )}
                                value={{
                                  value: i?.type || "",
                                  label: i?.type || "",
                                }}
                                onChange={e => {
                                  validation.setFieldValue(
                                    `bettingRates.${index}.type`,
                                    e?.value || ""
                                  )
                                }}
                              />
                              <Input
                                name={`bettingRates[${index}].type`}
                                className="form-control d-none"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={
                                  validation.values.bettingRates[index]?.type ||
                                  ""
                                }
                                invalid={
                                  validation.touched?.bettingRates &&
                                  validation.errors?.bettingRates
                                    ? validation.touched?.bettingRates[index]
                                        ?.type &&
                                      validation.errors?.bettingRates[index]
                                        ?.type
                                      ? true
                                      : false
                                    : false
                                }
                              />
                              {validation.touched?.bettingRates &&
                              validation.errors?.bettingRates ? (
                                <FormFeedback type="invalid">
                                  {validation.errors?.bettingRates[index]?.type}
                                </FormFeedback>
                              ) : null}
                            </Col>
                            <Col sm="3">
                              <Input
                                name={`bettingRates[${index}].bettingRate`}
                                className="form-control"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={
                                  validation.values.bettingRates[index]
                                    ?.bettingRate || ""
                                }
                                invalid={
                                  validation.touched?.bettingRates &&
                                  validation.errors?.bettingRates
                                    ? validation.touched?.bettingRates[index]
                                        ?.bettingRate &&
                                      validation.errors?.bettingRates[index]
                                        ?.bettingRate
                                      ? true
                                      : false
                                    : false
                                }
                              />
                              {validation.touched?.bettingRates &&
                              validation.errors?.bettingRates ? (
                                <FormFeedback type="invalid">
                                  {
                                    validation.errors?.bettingRates[index]
                                      ?.bettingRate
                                  }
                                </FormFeedback>
                              ) : null}
                            </Col>
                          </React.Fragment>
                          {index ===
                          validation.values.bettingRates.length - 1 ? (
                            <Col
                              sm="1"
                              className="d-flex align-items-center justify-content-start"
                            >
                              <div
                                role="button"
                                style={{ cursor: "pointer" }}
                                className="w-100 border border-1 border-dark rounded-circle d-flex align-items-center justify-content-center"
                                onClick={() => {
                                  if (
                                    validation.values.bettingRates.length < 2
                                  ) {
                                    const newVal = [
                                      ...validation.values.bettingRates,
                                      { type: "", bettingRate: "" },
                                    ]
                                    validation.setFieldValue(
                                      "bettingRates",
                                      newVal
                                    )
                                  }
                                }}
                              >
                                +
                              </div>
                            </Col>
                          ) : (
                            ""
                          )}

                          {index !==
                          validation.values.bettingRates.length - 1 ? (
                            <Col
                              sm="1"
                              className="d-flex align-items-center justify-content-start"
                            >
                              <div
                                role="button"
                                style={{ cursor: "pointer" }}
                                className="w-100 border border-1 border-dark rounded-circle d-flex align-items-center justify-content-center"
                                onClick={() => {
                                  const _temp = [
                                    ...validation.values.bettingRates,
                                  ] // make a separate copy of the array
                                  let removeIndex = _temp
                                    .map(function (_, i) {
                                      return i
                                    })
                                    .indexOf(index)

                                  _temp.splice(removeIndex, 1)

                                  validation.setFieldValue(
                                    "bettingRates",
                                    _temp
                                  )
                                }}
                              >
                                -
                              </div>
                            </Col>
                          ) : (
                            ""
                          )}
                        </FormGroup>
                      ))}
                    </Col>
                  </Row>
                </Form>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  )
}
